import { Component, Input, HostListener, Output, EventEmitter, ElementRef, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

import { ChartingService } from '../../services';
import { Dimensions, ICoordinates } from '../../models';

@Component({
    selector: '[aaListeningZone]',
    templateUrl: './listening-zone.component.html',
    styleUrls: [
        './listening-zone.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListeningZoneComponent implements OnInit
{
    public dimensions: Observable<Dimensions>;
    @Input() shiftClient: boolean = false;
    @Output() mousePosition: EventEmitter<[number, number]> = new EventEmitter<[number, number]>();
    @Output() clickEvent: EventEmitter<ICoordinates> = new EventEmitter<ICoordinates>();
    @Output() hovered: EventEmitter<boolean> = new EventEmitter<boolean>();
    private shiftLeft: number = 0;
    private shiftTop: number = 0;

    constructor (
        private elementRef: ElementRef,
        public chartingService: ChartingService
    )
    {
        this.dimensions = this.chartingService.dimensionsStore;
    }

    ngOnInit (): void
    {
        if (this.shiftClient)
        {
            const { x, y } = this.elementRef.nativeElement.getBoundingClientRect();

            this.shiftLeft = x;
            this.shiftTop = y;
        }
    }

    @HostListener('click', ['$event'])
    mouseClickEvent ($event: MouseEvent): void
    {
        this.clickEvent.emit({ x: $event.clientX - this.shiftLeft, y: $event.clientY - this.shiftTop });
    }

    @HostListener('mousemove', ['$event'])
    mouseMoveEvent ($event: MouseEvent): void
    {
        this.hovered.emit(true);
        this.mousePosition.emit([$event.clientX - this.shiftLeft, $event.clientY - this.shiftTop]);
    }

    @HostListener('mouseleave')
    mouseLeaveEvent (): void
    {
        this.hovered.emit(false);
    }
}
